import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchChargeDetail } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      list: null,
      loading: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      this.getDetail();
    }
  },
  created: function created() {
    this.getDetail();
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.loading = true;
      fetchChargeDetail({
        id: this.keyValue
      }).then(function (res) {
        _this.loading = false;

        if (res.data.code === 200) {
          _this.list = res.data.data;
        }
      });
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  }
};